// extracted by css-extract-rspack-plugin
export default {"boldText":"_a619a7d1"};